import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from "recharts";
import { TrendingUp } from "lucide-react";
import { toast } from "sonner";
import { apiClient } from "../utils/apiClient";

const ProgressTracking = () => {
  const { projectId } = useParams();
  const [progressData, setProgressData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProgressData();
  }, [projectId]);

  const fetchProgressData = async () => {
    try {
      const response = await apiClient.get(`/dashboard/${projectId}`);
      setProgressData(response.data.progress_data);
    } catch (error) {
      toast.error("Failed to fetch progress data");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-12">Loading...</div>;
  }

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-heading font-bold text-4xl text-primary tracking-tight">PROGRESS TRACKING</h1>
        <p className="text-slate-600 mt-2 font-body">Planned vs Actual Analysis</p>
      </div>

      {progressData && progressData.length > 0 ? (
        <>
          <div className="stat-card mb-8">
            <h3 className="font-heading font-bold text-xl mb-6 uppercase tracking-wide">Activity-wise Progress</h3>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={progressData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="activity" tick={{ fontSize: 12 }} angle={-15} textAnchor="end" height={100} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip />
                <Legend />
                <Bar dataKey="planned" fill="#0F172A" name="Planned Quantity" />
                <Bar dataKey="completed" fill="#10B981" name="Completed Quantity" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="stat-card">
            <h3 className="font-heading font-bold text-xl mb-6 uppercase tracking-wide">Completion Percentage</h3>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={progressData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="activity" tick={{ fontSize: 12 }} angle={-15} textAnchor="end" height={100} />
                <YAxis tick={{ fontSize: 12 }} domain={[0, 100]} />
                <Tooltip />
                <Legend />
                <Bar dataKey="percentage" fill="#F97316" name="Completion %" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>
      ) : (
        <div className="text-center py-16 stat-card">
          <TrendingUp className="w-16 h-16 mx-auto mb-4 text-slate-400" />
          <h3 className="font-heading font-bold text-xl mb-2">No Progress Data</h3>
          <p className="text-slate-600">Add BOQ items and DPR entries to see progress analysis.</p>
        </div>
      )}
    </div>
  );
};

export default ProgressTracking;